import { Expose } from "class-transformer";
import { IsNotEmpty, IsString } from "class-validator";

export class FindUserMatchesInput {
  @Expose()
  @IsString()
  @IsNotEmpty()
  buildStudioId!: string;
}
